import React from "react";



import { ComponentMap } from "../../tools/hydrator/@types/hydrator.types";

const EnergyLabelContainer = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/EnergyLabel/energyLabel.container"
    ).then(module => ({
        default: module.EnergyLabelContainer,
    })),
);



const ErrorMessages = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/ErrorMessages/errorMessages.container"
    ).then(module => ({
        default: module.ErrorMessages,
    })),
);



const FlyoutMenu = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/General/FlyoutMenu/flyoutMenu.container"
    ).then(module => ({
        default: module.FlyoutMenu,
    })),
);



const ProductTileAdapter = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/Product/ProductTile/productTile.adapter"
    ).then(module => ({
        default: module.ProductTileAdapter,
    })),
);

const Hamburger = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/General/Hamburger/hamburger.container"
    ).then(module => ({
        default: module.Hamburger,
    })),
);

const HeaderButtonContainer = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/General/HeaderButton/headerButton.container"
    ).then(module => ({
        default: module.HeaderButtonContainer,
    })),
);



const LogoutButtonContainer = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/Account/LogoutButton/logoutButton.container"
    ).then(module => ({
        default: module.LogoutButtonContainer,
    })),
);



const LogoutLinkContainer = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/Account/LogoutLink/logoutLink.container"
    ).then(module => ({
        default: module.LogoutLinkContainer,
    })),
);



const MessagesContainer = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/General/Messages/messages.container"
    ).then(module => ({
        default: module.Messages,
    })),
);

const PreferredStoreButton = React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@components/PreferredStoreButton/preferredStoreButton.container"
    ).then(module => ({
        default: module.PreferredStoreButton,
    })),
);



const ProductFacingContainer = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/Ecorner/ProductFacing/productFacing.container"
    ).then(module => ({
        default: module.ProductFacingContainer,
    })),
);



const DiscountContainer = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/Discount/discount.container"
    ).then(module => ({
        default: module.DiscountContainer,
    })),
);

const ProfileMenuButtonContainer = React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@components/Account/Profile/ProfileMenuButton/profileMenuButton.container"
    ).then(module => ({
        default: module.ProfileMenuButtonContainer,
    })),
);

const Sidebar = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/General/Sidebar/sidebar.container"
    ).then(module => ({
        default: module.SidebarContainer,
    })),
);

const TextContainer = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/General/Text/text.container"
    ).then(module => ({
        default: module.TextContainer,
    })),
);

const TooltipContainer = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/General/Tooltip/tooltip.container"
    ).then(module => ({
        default: module.TooltipContainer,
    })),
);

const InactivityMonitorContainer = React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@components/Ecorner/InactivityMonitor/inactivityMonitor.container"
    ).then(module => ({ default: module.InactivityMonitorContainer })),
);

const ContentListBlock = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/ContentListBlock/contentListBlock.container"
    ).then(module => ({ default: module.ContentListBlock })),
);



const CartButtonContainer = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/CartButton/cartButton.container"
    ).then(module => ({
        default: module.CartButtonContainer,
    })),
);

const CheckoutButton = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/Checkout/CheckoutButton/checkoutButton.container"
    ).then(module => ({ default: module.CheckoutButton })),
);



const CheckoutDetailsButton = React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@components/Checkout/CheckoutDetailsButton/checkoutDetailsButton.container"
    ).then(module => ({ default: module.CheckoutDetailsButton })),
);

const AddToCartModalContainer = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/Modals/AddToCartModal/addToCartModal.container"
    ).then(module => ({ default: module.AddToCartModalContainer })),
);



const AccountButton = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/Account/AccountButton/accountButton.container"
    ).then(module => ({ default: module.AccountButtonContainer })),
);

const AuthorisationProvider = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@utils/authorisation/authorisation.provider"
    ).then(module => ({
        default: module.AuthorisationProvider,
    })),
);



const AddToWishlistModal = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/Wishlist/AddToWishlistModal/AddToWishlist.modal"
    ).then(module => ({
        default: module.AddToWishlistModal,
    })),
);

const SearchResults = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/Search/SearchResults/searchResults.container"
    ).then(module => ({
        default: module.SearchResults,
    })),
);

const BackToTop = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/Navigation/BackToTop/backToTop.container"
    ).then(module => ({
        default: module.BackToTop,
    })),
);

const FeatureSwitch = React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@components/Utils/featureSwitch/featureSwitch.container"
    ).then(module => ({
        default: module.FeatureSwitchContainer,
    })),
);

export const componentMap: ComponentMap = {
    "hubofoundation-brand-hubo/components/ecorner/inactivity-monitor":
        InactivityMonitorContainer,
    "hubofoundation-brand-hubo/components/product/ecorner/facing-component":
        ProductFacingContainer,
    "hubofoundation-brand-hubo/components/navigation/sidebar-component":
        Sidebar,
    "hubofoundation-brand-hubo/components/navigation/account-button-component":
        AccountButton,
    "hubofoundation-brand-hubo/components/navigation/header-button-component":
        HeaderButtonContainer,
    "hubofoundation-brand-hubo/components/cart/discount-component":
        DiscountContainer,
    "hubofoundation-brand-hubo/components/product/energy-label-component":
        EnergyLabelContainer,
    "hubofoundation-brand-hubo/components/general/tooltip-component":
        TooltipContainer,
    "hubofoundation-brand-hubo/components/general/text-component":
        TextContainer,
    "hubofoundation-brand-hubo/components/account/logout-button-component":
        LogoutButtonContainer,
    "hubofoundation-brand-hubo/components/navigation/flyout-menu-component":
        FlyoutMenu,
    "hubofoundation-brand-hubo/components/navigation/header/hamburger-component":
        Hamburger,
    "hubofoundation-brand-hubo/components/navigation/cart-button-component":
        CartButtonContainer,
    "hubofoundation-brand-hubo/components/cart/checkout-details-button-component":
        CheckoutDetailsButton,
    "hubofoundation-brand-hubo/components/cart/checkout-button-component":
        CheckoutButton,
    "hubofoundation-brand-hubo/components/general/error-messages-component":
        ErrorMessages,
    "hubofoundation-brand-hubo/components/general/link-list-tile-component":
        ContentListBlock,
    "hubofoundation/components/store/preferred-store-button-component":
        PreferredStoreButton,
    "hubofoundation-brand-hubo/components/account/profile-menu-button-component":
        ProfileMenuButtonContainer,
    "hubofoundation-brand-hubo/components/product/product-tile-component":
        ProductTileAdapter,
    "hubofoundation-brand-hubo/components/general/message-component":
        MessagesContainer,
    "hubofoundation-brand-hubo/components/navigation/logout-link-component":
        LogoutLinkContainer,
    "hubofoundation-brand-hubo/components/modal/add-to-cart-modal-component":
        AddToCartModalContainer,
    "hubofoundation-brand-hubo/components/general/authorisation-provider-component":
        AuthorisationProvider,
    "hubofoundation-brand-hubo/components/wishlist/wishlist-modal":
        AddToWishlistModal,
    "hubofoundation-brand-hubo/components/navigation/back-to-top-component":
        BackToTop,
    "hubofoundation-brand-hubo/components/general/feature-switch-component":
        FeatureSwitch,
};
